import { defineMessages } from "react-intl";

const messages = defineMessages({
  activityRequiredRelationshipAlertCancelButton: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertCancelButton",
    defaultMessage: "No, keep as is",
    description: "Alert cancel button title when relationship field is marked as required",
  },
  activityRequiredRelationshipAlertCompanyEmailVariantLayoutDescription: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertCompanyEmailVariantLayoutDescription",
    defaultMessage:
      "To keep the ability to email People records for all users with this layout, do not require this field in the email variant.",
    description:
      "Alert title when company relationship field is marked as required in email variant layout",
  },
  activityRequiredRelationshipAlertCompanyPrimaryLayoutDescription: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertCompanyPrimaryLayoutDescription",
    defaultMessage:
      "We highly recommend marking this field “not required” in an email variant if you have not already done so. This will allow users with this layout to bulk email People.",
    description:
      "Alert title when company relationship field is marked as required in primary layout",
  },
  activityRequiredRelationshipAlertCompanySubTitle: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertCompanySubTitle",
    defaultMessage: "Users might be blocked from sending emails to People.",
    description: "Alert subtitle when company relationship field is marked as required",
  },
  activityRequiredRelationshipAlertDealEmailVariantLayoutDescription: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertDealEmailVariantLayoutDescription",
    defaultMessage:
      "To keep the ability to email records for all users with this layout, do not require this field in the email variant.",
    description:
      "Alert title when deal relationship field is marked as required in email variant layout",
  },
  activityRequiredRelationshipAlertDealPrimaryLayoutDescription: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertDealPrimaryLayoutDescription",
    defaultMessage:
      "We highly recommend marking this field “not required” in an email variant if you have not already done so. This will allow users with this layout to bulk email records.",
    description: "Alert title when deal relationship field is marked as required in primary layout",
  },
  activityRequiredRelationshipAlertDealSubTitle: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertDealSubTitle",
    defaultMessage: "Users might be blocked from sending bulk emails.",
    description: "Alert subtitle when deal relationship field is marked as required",
  },
  activityRequiredRelationshipAlertOkButton: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertOkButton",
    defaultMessage: "Yes, mark required",
    description: "Alert ok button title when relationship field is marked as required",
  },
  activityRequiredRelationshipAlertPersonEmailVariantLayoutDescription: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertPersonEmailVariantLayoutDescription",
    defaultMessage:
      "To keep the ability to email Company records for all users with this layout, do not require this field in the email variant.",
    description:
      "Alert title when person relationship field is marked as required in email variant layout",
  },
  activityRequiredRelationshipAlertPersonPrimaryLayoutDescription: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertPersonPrimaryLayoutDescription",
    defaultMessage:
      "We highly recommend marking this field “not required” in an email variant if you have not already done so. This will allow users with this layout to bulk email Companies.",
    description:
      "Alert title when person relationship field is marked as required in primary layout",
  },
  activityRequiredRelationshipAlertPersonSubTitle: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertPersonSubTitle",
    defaultMessage: "Users might be blocked from sending bulk emails to Companies.",
    description: "Alert subtitle when person relationship field is marked as required",
  },
  activityRequiredRelationshipAlertTitle: {
    id: "settings.formLayouts.canvas.actions.activityRequiredRelationshipAlertTitle",
    defaultMessage: "Are you sure?",
    description: "Alert title when relationship field is marked as required",
  },
  cancelButton: {
    id: "settings.formLayouts.canvas.actions.required.cancelButton",
    defaultMessage: "Cancel",
    description: "Email feature will affected warning. Cancel",
  },
  continueButton: {
    id: "settings.formLayouts.canvas.actions.required.continueButton",
    defaultMessage: "Continue",
    description: "Email feature will affected warning. Title",
  },
  dontRequire: {
    id: "settings.formLayouts.canvas.actions.dontRequire",
    defaultMessage: "Do not require",
    description: "Tooltip of Do not require action",
  },
  markRequired: {
    id: "settings.formLayouts.canvas.actions.markRequired",
    defaultMessage: "Mark required",
    description: "Tooltip of Mark required action",
  },
  personNameAllRequired: {
    id: "settings.formLayouts.canvas.actions.personNameAllRequired",
    defaultMessage: "Require both first and last name",
    description: "Menu item of person name - all required",
  },
  personNameFirstNameRequired: {
    id: "settings.formLayouts.canvas.actions.personNameFirstNameRequired",
    defaultMessage: "Require only first name",
    description: "Menu item of person name - first name required",
  },
  personNameLastNameRequired: {
    id: "settings.formLayouts.canvas.actions.personNameLastNameRequired",
    defaultMessage: "Require only last name",
    description: "Menu item of person name - first last required",
  },
  personNameNoneRequired: {
    id: "settings.formLayouts.canvas.actions.personNameNoneRequired",
    defaultMessage: "Require either first or last name",
    description: "Menu item of person name - none required",
  },
  uniqueCustomFieldRequiredAlertDescription: {
    id: "settings.formLayouts.canvas.actions.uniqueCustomField.required.alert.description",
    defaultMessage:
      "This field’s values must be unique. Marking required will prevent users from adding records <b>in bulk</b> using Lead Finder and MMC Email.",
    description: "Alert description when unique custom field is marked as required",
  },
  uniqueCustomFieldRequiredAlertTitle: {
    id: "settings.formLayouts.canvas.actions.uniqueCustomField.required.alert.title",
    defaultMessage: "Are you sure?",
    description: "Alert title when unique custom field is marked as required",
  },
});

export default messages;
